module.exports = __webpack_public_path__ + "img/healthcheck-head-long@2x.7565b885.png";